import axios from "axios";

export default {
    async getCategorieFoto() {
        const response = await axios.get("rest/v1/search/rel_interventi_immagini_categoria", {
            headers: {
                Authorization: process.env.VUE_APP_TOKEN,
            },
        });
        //console.log(response);
        return response.data.data;
    },
};
